import { Box } from "@mui/material";
import { useLoaderData } from "react-router";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/effect-flip";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/zoom";
import { Keyboard, Mousewheel, Navigation, Zoom } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Header } from "../Header/header";
import { ProjectData } from "../NavigationData/ProjectData";
import { AnimatedLayout } from "../Router/AnimatedLayout";

function ProjectDisplay({ project }: { project: ProjectData }) {
  const folder = `/images/${project.name}`;
  const images = new Array(project.pages).fill("").map((_, index) => `${folder}/${index + 1}.png`);

  return (
    <AnimatedLayout>
      <Header project={project} />
      <Box sx={{ flex: 1, minHeight: 0, padding: "1rem", backgroundColor: "#1414149f" }}>
        <Swiper
          mousewheel={true}
          zoom={true}
          keyboard={true}
          navigation={true}
          grabCursor={true}
          modules={[Navigation, Keyboard, Mousewheel, Zoom]}
          style={{
            display: "flex",
            width: "100%",
            maxHeight: "100%",
            flex: "0 0 auto",
            minWidth: 0,
            minHeight: 0,
          }}
        >
          {images.map((img) => (
            <SwiperSlide
              key={img}
              style={{
                overflow: "hidden",
              }}
            >
              <div className="swiper-zoom-container">
                <img src={img} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
    </AnimatedLayout>
  );
}

export function Project() {
  const data = useLoaderData();
  const project = data?.project;

  return <>{project && <ProjectDisplay project={project} />}</>;
}
